module.exports = __webpack_public_path__ + "b3e778728bf25196b72abdf6a75866c8.png";